import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'

export const AccountGroupPopup = (props) => {
    return (
        <ModalBasic
            id="accountGroup"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Account group details</span>
                <div className='item-grp grid grid-cols-2 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Account group no.</label>
                        <TextInput type='number'
                            id='accGrpNo' name='accGrpNo'
                            value={props.accountObject.accGrpNo}
                            handleChange={(event) => props.handleChange(event, 'accGrpNo')}
                            className={props.validState?.error?.accGrpNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Account group name:</label>
                        <TextInput type='text'
                            id='accGrpName' name='accGrpName'
                            value={props.accountObject.accGrpName}
                            handleChange={(event) => props.handleChange(event, 'accGrpName')}
                            className={props.validState?.error?.accGrpName !== undefined ? "error" : ""}
                        />
                    </div>
                </div>
                <div className='item-grp grid grid-cols-2 gap-2.5 mb-2.5'>
                    <div className='input-grp'>
                        <label>Group description:</label>
                        <TextInput type='text'
                            id='grpDesc' name='grpDesc'
                            value={props.accountObject.grpDesc}
                            handleChange={(event) => props.handleChange(event, 'grpDesc')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.accountObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                </div>

                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}